import React from 'react';
import { EditButton, TopToolbar } from 'react-admin';

export default ({ basePath, data, permissions }) => (
    <TopToolbar>
        {permissions && permissions.indexOf('PatchDevice') >= 0 && <EditButton basePath={basePath} record={data} />}
    </TopToolbar>
);
